<template>
    <div class="monitor-map-warp">
        <div class="line line-1"></div>
        <div class="line line-2"></div>
        <div class="line line-3"></div>
    </div>
</template>

<script>
    export default {
        props: {

        }
    }
</script>

<style lang="less" scoped>
    .monitor-map-warp {
        position: relative;
        margin: 0 30px;
        width: 474px;
        height: 474px;

        &::after {
            content: " ";
            position: absolute;
            top: 28px;
            left: 0;
            width: 474px;
            height: 474px;
            background-image: url("/static/images/home/monitor/map.png");
            background-size: 100%;
            background-repeat: no-repeat;
            background-position: center;
        }

        .line {
            position: absolute;
            background-size: 100%;
            background-repeat: no-repeat;
            // background-position: center;

            &.line-1 {
                top: 38px;
                left: -200px;
                width: 284px;
                height: 66px;
                background-image: url("/static/images/home/monitor/line-1.png");
            }

            &.line-2 {
                top: 68px;
                right: -34px;
                width: 117px;
                height: 39px;
                background-image: url("/static/images/home/monitor/line-2.png");
            }

            &.line-3 {
                bottom: -5px;
                left: -200px;
                width: 328px;
                height: 38px;
                background-image: url("/static/images/home/monitor/line-3.png");
            }
        }
    }
</style>
